module.exports = __webpack_public_path__ + "img/zc4.fa75d50d.png";